import { FC, useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Bell } from 'lucide-react'
import { fetchFromApi } from '@utils/apiOrigin'
import { getTicketAuthHeaders } from '@utils/ticketLabels'
import { useAuth } from '@store/auth/AuthProvider'

const POLL_MS = 60 * 1000

export const NotificationBell: FC = () => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [count, setCount] = useState(0)

  const refresh = useCallback(async () => {
    if (!isAuthenticated) return
    try {
      const res = await fetchFromApi('/api/tickets/unread-count', { headers: getTicketAuthHeaders() })
      if (!res.ok) return
      const { data } = await res.json()
      setCount(data.count || 0)
    } catch {
      // sin notificaciones si falla el polling
    }
  }, [isAuthenticated])

  useEffect(() => {
    void refresh()
    const timer = setInterval(() => void refresh(), POLL_MS)
    return () => clearInterval(timer)
  }, [refresh])

  useEffect(() => {
    void refresh()
  }, [location.pathname, refresh])

  if (!isAuthenticated) return null

  return (
    <button
      onClick={() => navigate('/soporte')}
      className="relative p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-colors"
      aria-label={count > 0 ? `Soporte Web: ${count} mensajes sin leer` : 'Soporte Web'}
      title="Soporte Web y sugerencias"
    >
      <Bell className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  )
}
